<div class="title">
    {{ 'dashboard:Time Range' | i18next }}
</div>

<div class="dialog-content">
    <div class="from-to-container">
        <div class="from-time-label">
            {{ 'dashboard:From' | i18next }}
        </div>
        <div class="to-time-label">
            {{ 'dashboard:To' | i18next }}
        </div>
    </div>
    <br />
    <div class="radio-group">
        <div class="radio-button-container">
            <div class="radio-button">
                <mat-radio-button (click)="onAllClick()" [checked]="filters.allDays['checked']">{{ 'dashboard:All days'
                    | i18next }}</mat-radio-button>
                <!-- <input type="radio" id="all" name="filterType" [checked]="filters.allDays['checked']"
                    (click)="onAllClick()">
                <label for="all">{{ 'dashboard:All days' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.allDays['from']" [type]="'from'"
                    [disabled]="!filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'allDays')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.allDays['to']" [type]="'to'"
                    [disabled]="!filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'allDays')"></app-range-time-picker>
            </div>
        </div>
        <div class="radio-button">
            <mat-radio-button (click)="onSpecificClick()" [checked]="specificChecked">{{ 'dashboard:Specify days'
                | i18next }}</mat-radio-button>
            <!-- <input type="radio" id="specific" name="filterType" [checked]="specificChecked" (click)="onSpecificClick()">
            <label for="specific">{{ 'dashboard:Specify days' | i18next }}</label> -->
        </div>
    </div>
    <div class="specify-radio-group">
        <div class="radio-button-container">
            <div class="specific-radio-button">
                <mat-checkbox class="checkbox" id="monday" [checked]="filters.monday['checked']"
                    [disabled]="specificDaysDisabled" (change)="radioButtonState($event)">{{ 'dashboard:Monday' |
                    i18next }}</mat-checkbox>
                <!-- <label for="monday">{{ 'dashboard:Monday' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.monday['from']" [type]="'from'"
                    [disabled]="!filters.monday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'monday')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.monday['to']" [type]="'to'"
                    [disabled]="!filters.monday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'monday')"></app-range-time-picker>
            </div>
        </div>
        <div class="radio-button-container">
            <div class="specific-radio-button">
                <mat-checkbox class="checkbox" id="tuesday" [checked]="filters.tuesday['checked']"
                    [disabled]="specificDaysDisabled" (change)="radioButtonState($event)">{{ 'dashboard:Tuesday' |
                    i18next }}</mat-checkbox>
                <!-- <label for="tuesday">{{ 'dashboard:Tuesday' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.tuesday['from']" [type]="'from'"
                    [disabled]="!filters.tuesday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'tuesday')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.tuesday['to']" [type]="'to'"
                    [disabled]="!filters.tuesday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'tuesday')"></app-range-time-picker>
            </div>
        </div>
        <div class="radio-button-container">
            <div class="specific-radio-button">
                <mat-checkbox class="checkbox" id="wednesday" [checked]="filters.wednesday['checked']"
                    [disabled]="specificDaysDisabled" (change)="radioButtonState($event)">{{ 'dashboard:Wednesday' |
                    i18next }}</mat-checkbox>
                <!-- <label for="wednesday">{{ 'dashboard:Wednesday' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.wednesday['from']" [type]="'from'"
                    [disabled]="!filters.wednesday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'wednesday')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.wednesday['to']" [type]="'to'"
                    [disabled]="!filters.wednesday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'wednesday')"></app-range-time-picker>
            </div>
        </div>
        <div class="radio-button-container">
            <div class="specific-radio-button">
                <mat-checkbox class="checkbox" id="thursday" [checked]="filters.thursday['checked']"
                    [disabled]="specificDaysDisabled" (change)="radioButtonState($event)">{{ 'dashboard:Thursday' |
                    i18next }}</mat-checkbox>
                <!-- <label for="thursday">{{ 'dashboard:Thursday' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.thursday['from']" [type]="'from'"
                    [disabled]="!filters.thursday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'thursday')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.thursday['to']" [type]="'to'"
                    [disabled]="!filters.thursday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'thursday')"></app-range-time-picker>
            </div>
        </div>
        <div class="radio-button-container">
            <div class="specific-radio-button">
                <mat-checkbox class="checkbox" id="friday" [checked]="filters.friday['checked']"
                    [disabled]="specificDaysDisabled" (change)="radioButtonState($event)">{{ 'dashboard:Friday' |
                    i18next }}</mat-checkbox>
                <!-- <label for="friday">{{ 'dashboard:Friday' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.friday['from']" [type]="'from'"
                    [disabled]="!filters.friday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'friday')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.friday['to']" [type]="'to'"
                    [disabled]="!filters.friday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'friday')"></app-range-time-picker>
            </div>
        </div>
        <div class="radio-button-container">
            <div class="specific-radio-button">
                <mat-checkbox class="checkbox" id="saturday" [checked]="filters.saturday['checked']"
                    [disabled]="specificDaysDisabled" (change)="radioButtonState($event)">{{ 'dashboard:Saturday' |
                    i18next }}</mat-checkbox>
                <!-- <label for="saturday">{{ 'dashboard:Saturday' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.saturday['from']" [type]="'from'"
                    [disabled]="!filters.saturday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'saturday')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.saturday['to']" [type]="'to'"
                    [disabled]="!filters.saturday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'saturday')"></app-range-time-picker>
            </div>
        </div>
        <div class="radio-button-container">
            <div class="specific-radio-button">
                <mat-checkbox class="checkbox" id="sunday" [checked]="filters.sunday['checked']"
                    [disabled]="specificDaysDisabled" (change)="radioButtonState($event)">{{ 'dashboard:Sunday' |
                    i18next }}</mat-checkbox>
                <!-- <label for="sunday">{{ 'dashboard:Sunday' | i18next }}</label> -->
            </div>
            <div>
                <app-range-time-picker [(time)]="filters.sunday['from']" [type]="'from'"
                    [disabled]="!filters.sunday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'from', 'sunday')"></app-range-time-picker>
            </div>
            <div class="to-time">
                <app-range-time-picker [(time)]="filters.sunday['to']" [type]="'to'"
                    [disabled]="!filters.sunday['checked'] || filters.allDays['checked']"
                    (timeChange)="onTimeChange($event, 'to', 'sunday')"></app-range-time-picker>
            </div>
        </div>
    </div>
</div>

<mat-dialog-actions>
    <button mat-flat-button (click)="onCancelClick()" [ngClass]="['secondary-button']">{{ 'Cancel' | i18next }}</button>
    <button mat-flat-button (click)="onApplyClick()" [ngClass]="['primary-button']">{{ 'Apply Changes' | i18next
        }}</button>
</mat-dialog-actions>